import React from "react";
import { Link } from "react-router-dom";
import { Stack, Typography } from "@mui/material";

import { supportedLanguages, useLocale } from "src/shared/i18n";

export const LocaleSwitcher: React.FC = () => {
  const { language, hrefForLanguage } = useLocale();

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={0.5}
      sx={{ marginLeft: "10px", order: { md: "initial", xs: 4 } }}
      aria-label="Language selector"
    >
      {supportedLanguages.map((lng, index) => (
        <React.Fragment key={lng}>
          {index > 0 && (
            <Typography variant="caption" color="text.primary" aria-hidden>
              /
            </Typography>
          )}
          <Typography
            component={Link}
            to={hrefForLanguage(lng)}
            variant="caption"
            aria-current={lng === language ? "true" : undefined}
            sx={{
              textTransform: "uppercase",
              letterSpacing: 1,
              cursor: "pointer",
              color: lng === language ? "primary.main" : "text.primary",
              "&:hover": { color: "primary.main" },
            }}
          >
            {lng}
          </Typography>
        </React.Fragment>
      ))}
    </Stack>
  );
};
